import { AlertMessage } from "@/components/AlertMessage";
import {
  ERROR_MESSAGES_DA,
  getValidationFieldErrors,
} from "@/api/cle-api/errors";
import { useCleApiError } from "@/hooks/cle-hooks/useCleApiError";

interface CleApiErrorAlertProps {
  error: unknown;
  heading?: string;
  fallback?: string;
  className?: string;
}

export const CleApiErrorAlert = ({
  error,
  heading = "Fejl",
  fallback = ERROR_MESSAGES_DA.INTERNAL_ERROR,
  className,
}: CleApiErrorAlertProps) => {
  const { userMessage, hasError, body } = useCleApiError(error, fallback);
  const hasFieldErrors =
    body?.code === "VALIDATION_ERROR" &&
    Object.keys(getValidationFieldErrors(body)).length > 0;

  if (!hasError || hasFieldErrors) return null;

  return (
    <AlertMessage
      heading={heading}
      type="danger"
      warningIcon
      className={className}
    >
      <p className="mb-0">{userMessage}</p>
    </AlertMessage>
  );
};
